import React from "react";
import styles from "./PropertySelector.module.scss";
import classnames from "classnames";
import { TurnrErrorAlert } from "~/components/alerts/TurnrAlert";
import { anyExchangeAlternativeExists } from "~/cores/exchangeToProductsCore";
import lodashClone from "lodash/clone";
import { serviceIsFetched } from "rylak-common";
import DropdownPropertySelector from "./selectors/DropdownPropertySelector";
import CheckboxImagePropertySelector from "./selectors/CheckboxImagePropertySelector";
import CheckboxColorPropertySelector from "./selectors/CheckboxColorPropertySelector";
import CheckboxPropertySelector from "./selectors/CheckboxPropertySelector";
import { getPropertyTypeTitle } from "./propertyCore";
import { getBrandShouldForceDropdownPropertyPicker } from "~/cores/brandDataCore";

function getPropertySelectorRenderer({ propertyValues, appProps }) {
    const useDropdownInstead = propertyValues?.length > 10 || getBrandShouldForceDropdownPropertyPicker(appProps);
    const hasImage = !!propertyValues?.[0].imageSrc;
    const hasHexColor = !!propertyValues?.[0].hexColor;

    if (useDropdownInstead) {
        return DropdownPropertySelector;
    }
    if (hasImage) {
        return CheckboxImagePropertySelector;
    }
    if (hasHexColor) {
        return CheckboxColorPropertySelector;
    }

    return CheckboxPropertySelector;
}

export default function PropertySelector(props) {
    const { appProps, propertyMap, selectedAlternative, selectedProperties, setSelectedProperties, showPropertyError, productExchangeServiceData, similarProductServiceData } = props;
    const { getLocaleText } = appProps;

    const similarProducts = similarProductServiceData?.data?.similarProducts;
    const noPropertiesAvailable =
        !(similarProducts?.length > 0) && serviceIsFetched(similarProductServiceData) && !anyExchangeAlternativeExists(productExchangeServiceData?.data) && !selectedAlternative;

    return (
        <div className={classnames(styles["property-wrapper"], showPropertyError && noPropertiesAvailable && styles["property-wrapper-error"])}>
            {Object.keys(propertyMap)?.map((propertyType) => {
                let propertyValues = propertyMap[propertyType]?.sort((a, b) => (a?.displayPriority ?? Infinity) - (b?.displayPriority ?? Infinity));

                const PropertySelectorRenderer = getPropertySelectorRenderer({ propertyValues, appProps });

                const selectedPropertyValue = selectedProperties[propertyType];
                const onSelectedPropertyValue = ({ propertyValue, deSelectEnabled = true }) => {
                    if (deSelectEnabled && selectedPropertyValue === propertyValue) {
                        delete selectedProperties[propertyType];
                    } else {
                        selectedProperties[propertyType] = propertyValue;
                    }
                    setSelectedProperties(lodashClone(selectedProperties));
                };

                return (
                    <div key={propertyType} className={classnames(styles["product-property"])}>
                        <h3 className={styles["product-property-header"]}>{getPropertyTypeTitle({ appProps, propertyType })}</h3>

                        <PropertySelectorRenderer
                            {...props}
                            propertyType={propertyType}
                            propertyValues={propertyValues}
                            selectedPropertyValue={selectedPropertyValue}
                            onSelectedPropertyValue={onSelectedPropertyValue}
                        />
                    </div>
                );
            })}

            {noPropertiesAvailable && <TurnrErrorAlert fullWidth>{getLocaleText("return-items-exchange-product-no-items")}</TurnrErrorAlert>}
        </div>
    );
}
